import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, Platform, ToastController } from '@ionic/angular';
import { vars } from '../../app.constants';
import { TextableService } from 'src/app/services/textable-service.service';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment-timezone';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MessageContextService } from 'src/app/gesture.service';
import { PopoverAndToastService } from 'src/app/popover-and-toast.service';


@Component({
  selector: 'app-edit-scheduled-message-modal',
  templateUrl: './edit-scheduled-message-modal.page.html',
  styleUrls: ['./edit-scheduled-message-modal.page.scss'],
})
export class EditScheduledMessageModalPage implements OnInit {

  timezones = vars.timezones;
  timezone;
  date;
  time;

  msg;

  pastBool = true;
  formDate;
  finalTime;
  currentDate = Date.now()

  frmEditScheduled: UntypedFormGroup = new UntypedFormGroup({
    "date": new UntypedFormControl(null, [Validators.required]),
    "scheduleTimezone": new UntypedFormControl(null, [Validators.required]),
    "id": new UntypedFormControl(null),
  });

  constructor(
    private modalController: ModalController,
    public navParams: NavParams,
    private textable: TextableService,
    private route: ActivatedRoute,
    public toastController: ToastController,
    private platform: Platform,
    private gestureService: MessageContextService,
    private patService: PopoverAndToastService
  ) { }

  ngOnInit() {
  }

  ionViewDidEnter() {

    this.route.params.subscribe(async (params) => {
      this.msg = await this.textable.getMessage(this.navParams.data.id).toPromise();  // TODO: TXBDEV-3024 use firstValueFrom here once we've upgraded angular / RxJs
      this.timezone = this.msg.scheduleTimezone;
      this.date = moment(this.msg.date).format();
      this.time = moment(this.msg.date).format();
      this.setUpDateVariables(this.msg);
    });
  }

  close(){
    this.modalController.dismiss();
  }
  save() {
    this.addDateToTime();
  }

  ///////////////////////
  // Date Format Methods
  ///////////////////////
  
  //This function sets up variables for use for the form.
  setUpDateVariables(msg) {
    this.formDate = moment(msg.date).format();
    this.frmEditScheduled.get('id').setValue(this.navParams.data.id)
    this.frmEditScheduled.get('scheduleTimezone').setValue(msg.scheduleTimezone)
    this.frmEditScheduled.get('date').setValue(this.formDate)
    this.formatTime();
  }

  //This functions corrects the time to the appropriate timezone.
  formatTime() {
    let newTime = new Date(this.frmEditScheduled.value.date).toLocaleString('en-US', { timeZone: this.frmEditScheduled.get('scheduleTimezone').value })
    this.frmEditScheduled.get('date').setValue(moment(newTime).format())
  }



  async addDateToTime() {
    try {
      let date = new Date(this.frmEditScheduled.get('date').value);
      let formDateAsDATE = new Date(this.formDate)
      let fullDate = new Date(
        formDateAsDATE.getFullYear(),
        formDateAsDATE.getMonth(),
        formDateAsDATE.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds())


      this.finalTime = this.showTime(fullDate);

      if (this.finalTime >= Date.now() && this.frmEditScheduled.get('scheduleTimezone').value != undefined) {
        this.frmEditScheduled.get('date').setValue(this.finalTime);
        this.pastBool = true;
        this.updateScheduledMessage();
      } else {
        this.pastBool = false;
      }
    } catch (e) {
      console.log(e)
      const toast = await this.toastController.create({
        message: 'Oops, there was a problem deleting this message. Please try again.',
        duration: 1500,
        position: 'top',
        color:'danger'
      });
      toast.present();
    }
  }

  async updateScheduledMessage() {
    await this.textable.editMessage(this.frmEditScheduled.value.id, this.frmEditScheduled.value)
    await this.patService.presentToast({
      message: 'Message Date Changed.',
      duration: 1500,
      position: 'top',
      color:'success',
      dismissPopovers: true,
      dismissModeal: true,
      removeHeldPress: true
    });
  }

  showTime(fullDate){
    this.currentDate = Date.now();
    let zone = this.frmEditScheduled.get('scheduleTimezone').value;
    let date = moment(fullDate);
    let ndate = date.format("YYYY-MM-DD HH:mm");
    return moment.tz(ndate, zone).valueOf();
  }

}
